<template>
  <div class="content content--sub">
    <MyHeader :breadcrumbItems="[

        {
          name: section.name,
          path: `/${$route.params.companySlug}/projects`
        }
      ]"/>

    <header class="content-header">
      <h1 v-html="section.name"></h1>
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList"><i class="icon-list"></i></button>
    </header>

    <!-- tabs for mobile -->
    <transition name="fade">
      <div class="article-list" v-if="showList">
        <TabMenuList :tabs="tabContent" @closeMenu="showList=false"></TabMenuList>
<!--        <div class="tabs-vertical">-->
<!--          <ul class="tabs-inner">-->
<!--            <li v-for="(tab, index) in tabContent" :key="tab.idSettingCompany">-->
<!--              <a :class="{'active': $route.query.tab ? (slugify(tab.value) === $route.query.tab) : index === 0}" @click="selectTab(tab)">-->
<!--                {{tab.value}}-->
<!--                <i class="icon-arrow"></i>-->
<!--              </a>-->
<!--            </li>-->
<!--            <li v-if="hireRequests.length">-->
<!--              <a :class="{'active': $route.query.tab ? ('hiring-requests' === $route.query.tab) : false}" @click="selectTab({value: 'Hiring Requests'})">-->
<!--                Hiring Requests-->
<!--                <i class="icon-arrow"></i>-->
<!--              </a>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->
      </div>
    </transition>

    <div class="container main-content--tabbed">
      <div class="row" v-if="tabContent.length">
        <div class="col-lg-3 d-none d-lg-block">
          <TabMenuList :tabs="tabContent"></TabMenuList>

<!--          <div class="tabs-vertical">-->
<!--            <ul class="tabs-inner">-->
<!--              <li v-for="(tab, index) in tabContent" :key="tab.idSettingCompany">-->
<!--                <a :class="{'active': $route.query.tab ? (slugify(tab.value) === $route.query.tab) : index === 0}" @click="selectTab(tab)">-->
<!--                  {{tab.value}}-->
<!--                  <i class="icon-arrow"></i>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li v-if="hireRequests.length">-->
<!--                <a :class="{'active': $route.query.tab ? ('hiring-requests' === $route.query.tab) : false}" @click="selectTab({value: 'Hiring Requests'})">-->
<!--                  Hiring Requests-->
<!--                  <i class="icon-arrow"></i>-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
        </div>
        <div class="col-lg-9 article-content">
          <div class="row boxes-row"  v-if="$route.query.tab && 'hiring-requests' === $route.query.tab">
            <div class="col-lg-4" v-for="hireRequest in hireRequests" :key="hireRequest.idHireRequest">
              <BoxHireRequest :box="hireRequest" />
            </div>
          </div>
          <div class="row boxes-row" v-else>
            <div class="col-lg-4" v-for="project in currentSelectedTab.projects" :key="project.idProject">
              <BoxProject :box="project" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import BoxHireRequest from "@/components/projects/BoxHireRequest";
import BoxProject from '@/components/projects/BoxProject'
import {slugify} from "@/helpers/slugify";
import settings from "@/settings";
import TabMenuList from "@/components/tabs/TabMenuList";
import tabsMixin from "@/mixins/tabsMixin";
export default {
  name: "Projects",
  components: {TabMenuList, BoxHireRequest, MyHeader, BoxProject},
  mixins: [tabsMixin],
  data () {
    return {
      showList: false,
    }
  },
  mounted() {
    this.getProjects()
    this.getHireRequests()
    window._paq.push(['setDocumentTitle', this.section.name]  );
    window._paq.push(['trackPageView']);
  },
  computed: {
    section() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'Projects'
      })
    },
    tabContent() {
      let tabs = this.$store.getters.settingsCompanyByCode(settings.SETTING_TYPES.PROJECTS_DOMAINS).map((item) => {
        return {
          name: item.value,
          slug: this.slugify(item.value),
          idType: item.idType,
          idSettingCompany: item.idSettingCompany,
          projects: this.$store.getters.projects.filter(elem => {
            return elem._embedded.Content.idType === item.idSettingCompany
          })
        }
      })
      if(this.hireRequests.length) {
        tabs.push({
          name: 'Hire Request',
          slug: 'hiring-requests',
        })
      }
      return tabs;
    },
    hireRequests() {
      return this.$store.getters.hireRequests
    },
    tabs() {
      return this.tabContent.map(item => {
        return {
          name: item.value,
          slug: slugify(item.value),
          idType: item.idType,
          idSettingCompany: item.idSettingCompany,
        }
      })
    },
  },
  methods: {
    getHireRequests() {
      this.$store.dispatch('getHireRequests')
    },
    getProjects() {
      this.$store.dispatch('getProjects')
    },
    getInitiatives() {
      this.$store.dispatch('getInitiatives')
    },
    slugify: slugify,
    //todo mixins do tego
    selectTab(tab) {
      let query = {
        tab: slugify(tab.value),
      }
      this.$router.push({query})
    }
  }
}
</script>
